import { Star, ArrowUpRight, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { REVIEWS_URL } from "./config";

const REVIEWS = [
  {
    quote:
      "La mejor atención de Guayaquil y encuentro de todo para mis pedidos de pastelería. Súper recomendados.",
    testid: "review-card-0",
  },
  {
    quote:
      "Excelente variedad de insumos y precios acordes a la calidad. Mi tienda de confianza en Plaza Quil.",
    testid: "review-card-1",
  },
];

export default function Reviews() {
  return (
    <section id="opiniones" className="relative py-14 sm:py-18 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <Eyebrow>Reseñas de Google</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-choco sm:text-4xl lg:text-5xl">
              Lo que dicen nuestros clientes
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-3 text-base text-cocoa sm:text-lg">
              Conoce por qué somos la tienda de decoración de pasteles
              preferida en Guayaquil.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-8">
          <div
            data-testid="reviews-score-card"
            className="mx-auto flex max-w-lg flex-col items-center gap-2 rounded-[2rem] border border-linebr bg-white px-8 py-6 shadow-[0_25px_60px_-35px_rgba(44,32,28,0.35)]"
          >
            <div className="flex items-end gap-3">
              <span className="font-display text-5xl font-bold leading-none text-choco">
                4.9
              </span>
              <span className="flex flex-col items-start gap-1 pb-1">
                <span className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-gold text-gold" />
                  ))}
                </span>
                <span className="text-xs font-bold uppercase tracking-widest text-sand">
                  Excelente
                </span>
              </span>
            </div>
            <p className="text-sm font-semibold text-cocoa">
              Calificación de nuestros clientes en Google
            </p>
          </div>
        </Reveal>

        <div className="mt-6 grid gap-5 md:grid-cols-2 lg:gap-7">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.testid} delay={0.1 + i * 0.12} className="h-full">
              <figure
                data-testid={r.testid}
                className="relative flex h-full flex-col rounded-[1.75rem] border border-linebr bg-white p-6 transition duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(232,162,56,0.4)] sm:p-8"
              >
                <Quote className="absolute right-6 top-6 h-7 w-7 text-blush" />
                <span className="flex gap-0.5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-5 w-5 fill-gold text-gold" />
                  ))}
                </span>
                <blockquote className="mt-4 flex-1 font-display text-lg italic leading-relaxed text-choco">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 text-sm font-bold text-cocoa">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cream2">
                    <span className="font-display text-base font-bold">G</span>
                  </span>
                  Reseña de Google
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-8 text-center">
          <a
            data-testid="review-google-link"
            href={REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border-2 border-choco/15 px-8 py-3.5 font-bold text-choco transition duration-300 hover:-translate-y-1 hover:border-gold hover:text-gold"
          >
            Ver opiniones en Google
            <ArrowUpRight className="h-5 w-5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
